<permission-checker [roles]="roles" (contentInit)="initContent()">
  <mat-form-field class="full-width">
    <mat-label [class.text-disabled-color]="disabled"
      i18n="Contest List|Select a contest prompt@@contest-list-select-one-prompt">Select a contest
    </mat-label>
    <mat-select [disabled]="disabled"
                (selectionChange)="contestSelected($event)"
                [compareWith]="compareWith"
                [value]="selectedValue">
      <mat-option *ngFor="let competition of contests" [value]="competition">{{competition.name}}</mat-option>
    </mat-select>
    <mat-spinner *ngIf="!contests" diameter="15" color="primary" matSuffix></mat-spinner>
  </mat-form-field>
</permission-checker>
